import PropTypes from "prop-types"
import { Text } from "components/Text"
import { Card, CardContent } from "components/Card"
import { useTranslator } from "components/Translator"
import { Avatar } from "components/Avatar"
import { getImageSrc } from "components/Image"

export function TestimonialCard(props) {
  const translator = useTranslator()
  const { testimonial, tag, href, className } = props
  const { content, updatedAt, user } = testimonial

  return (
    <Card tag={tag} href={href} className={className}>
      <CardContent className="space-y-4">
        <Text variant="body2">{content}</Text>
        <div className="flex flex-row space-x-4 pt-2">
          <Avatar
            className="w-12 h-12"
            src={user.imageFile ? getImageSrc(user.imageFile, "w400") : null}
            alt=""
          />
          <div className="flex flex-col space-y-2">
            <Text variant="headline6" className="text-primary-dark">
              {user.fullName}
            </Text>
            <Text variant="caption" className="text-light">
              {new Date(updatedAt).toLocaleDateString(translator.locale)}
            </Text>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}

TestimonialCard.propTypes = {
  testimonial: PropTypes.shape({
    id: PropTypes.number.isRequired,
    content: PropTypes.string.isRequired,
    createdAt: PropTypes.string.isRequired,
    updatedAt: PropTypes.string.isRequired,
    user: PropTypes.object.isRequired,
  }).isRequired,
}
